import axios from 'axios'

export default class RestClient {

  private axios: any;

  constructor({baseURL}) {
    this.axios = axios.create({
      baseURL: baseURL,
      transformRequest: [(data, headers) => {
        if (headers["Content-Type"] == "application/x-www-form-urlencoded") {
          var str = [];
          for (var p in data) {
            if (data.hasOwnProperty(p) && (!(data[p] == undefined || data[p] == null))) {
              str.push(encodeURIComponent(p) + "=" + encodeURIComponent(data[p]));
            }
          }
          return str.join("&");
        } else {
          return JSON.stringify(data);
        }
      }]
    });
  }

  get(args) {
      return this.axios.request(this._get.apply(this, arguments));
  }

  post(args) {
    return this.axios.request(this._post.apply(this, arguments));
  }

  _get(path, params, headers = {}) {
    var config = {
      method: "get",
      params: params,
      url: path,
      headers: headers
    }

    return config;
  }

  _post(path, data, headers = {}) {
    var config = {
      method: "post",
      data: data,
      url: path,
      headers: Object.assign({
        'Content-Type': 'application/x-www-form-urlencoded',
      }, headers)
    }

    return config;
  }
}